import Vue from 'vue'
import Router from 'vue-router'
import ArtistWorksSub from '../components/ArtistWorksSub'
import ArtistsSub from '../components/ArtistsSub'
import * as api from "../../../api";
import { store } from '../../../store/Works'

Vue.use(Router);

var site_short_url_lang=$('#app-wrapper').attr('site_short_url_lang');
document.site_short_url_lang=site_short_url_lang;

let cur_routes=[];

//страница художника
let artist_id=$('#app-wrapper').attr('artist_id');
let gallery_id=$('#app-wrapper').attr('gallery_id');
if ( (artist_id!=null && artist_id.length>0) || (gallery_id!=null && gallery_id.length>0) ) {
	let link=$('#app-wrapper').attr('link');

	let cmp=ArtistWorksSub;
	let cmp_artists=ArtistsSub;
  //window.theme=$('#app-wrapper').attr('theme');

  cur_routes=[];
	cur_routes.push(
		{
			path: link+'/works/for_sale',
			//path: '/artists/13825~Ivan_Konstantinovich_Ajvazovskij/works/for_sale',
			name: 'SaleArtistWorks',
			component: cmp,
		},
		{
			path: link+'/works/for_sale/:filter',
			name: '_SaleArtistWorks',
			component: cmp,
			props: true
		},
		{
			path: link+'/works',
			//path: '/artists/13825~Ivan_Konstantinovich_Ajvazovskij/works',
			name: 'ArtistWorks',
			component: cmp,
		},
		{
			path: link+'/works/:filter',
			name: '_ArtistWorks',
			component: cmp,
			props: true
		},
    {
      path: link+'/artists',
      //path: '/galleries/1/artists',
      name: 'GalleryArtists',
      component: cmp_artists,
    },
    {
      path: link+'/artists/:filter',
      name: '_GalleryArtists',
      component: cmp_artists,
      props: true
		}
  );
}

let _router=new Router({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  routes: cur_routes,

  //скролинг при смене роута
  /*scrollBehavior (to, from, savedPosition) {
    //https://router.vuejs.org/ru/guide/advanced/scroll-behavior.html
    switch (to.name) {
      case 'ExpertChoice':
      case 'Abstractions':
      case 'Landscapes':
      case 'StillLife':
      case 'Animalistics':
      case 'Photo':
      case 'Sale':
        return { selector: '#id_main_works_list' };
        //return { x: 0, y: 0 };
        break;
    }
  }*/
});

var orig_title=document.title;
var orig_description=$('meta[name=description]').attr('content');

_router.afterEach((to, from) => {
  let url='/action/vue/seo';

  //store.dispatch('setSeoTitle', '666');

  api.get(url, {path: to.path}, false, true).then(response => {

    let data=response.data;

    let title='';
    let description='';
    let seo_title='';
    let seo_text='';

    if ( data!=null ){
      let res=data['res'];
      if ( res!=null ){
        if ( res['title']!=null ) title=res['title'];
        if ( res['description']!=null ) description=res['description'];
        if ( res['seo_title']!=null ) seo_title=res['seo_title'];
        if ( res['seo_text']!=null ) seo_text=res['seo_text'];
      }
    }

    //console.log(seo_title);
    store.dispatch('setSeoTitle', seo_title);
    store.dispatch('setSeoText', seo_text);

    if ( title==null || title.length==0 ) title=orig_title;
    if ( title!=null && title.length>0 ) document.title=title;

    if ( description==null || description.length==0 ) description=orig_description;
    if ( description!=null && description.length>0 ) $('meta[name=description]').attr('content', description);

  }).catch(e => {
    console.log(e);
  });
});

export default _router;




//////////////////
// WEBPACK FOOTER
// ./src/sub/air_light/router/index.js
// module id = null
// module chunks = 